import React from "react";
import appConfig from "../../../config/app.config";

const staticAssetsUrl = appConfig.staticAssetsUrl;

const ContentProductPage = () => {
    return (
        <div >
            <h2 className="text-xl font-bold">3.Product Dashboard Page</h2>
            <div>
                <p>Basic customer information, Account information and available API details are on the Product Dashboard Page as shown in the screenshot below </p>
                <img className="pic" src={staticAssetsUrl + "user_manual/Products_Dasboard.png"} />
            </div>
            <div>
                <p> <span className="font-bold">3.1</span> Account specific information such as API Key, Client ID, Client Secret, Customer ID, Customer Account Number, iv-user etc. is shown on the Card Panel as shown in the below screenshot.</p>
                <img className="pic" src={staticAssetsUrl + "user_manual/card_panel.png"} />
            </div>
            <div>
                <p><span className="font-bold">3.2</span> The left side pane shows the list of products which you are eligible to use. </p>

                <p> <span className="font-bold">Please note that the Client ID, Client Secret, Customer ID, Customer Account Number and iv-user remain the same for all the subscribed products.</span></p>
                <img className="pic" src={staticAssetsUrl + "user_manual/left_side_panel.png"} />
            </div>
        </div>
    )
}

export default ContentProductPage;